<ng-container *ngIf="productView">
  <ng-container *ngIf="productView.variation === 'SINGLE'; else ELSE">
    <ng-container *ngIf="productView.variantAvailability as availability">
      <x-add-to-cart-button
        [label]="availability.reason?.label ?? productView.addToCartLabel"
        [disabled]="availability.status === 'UNAVAILABLE'"
        [disabledTooltip]="availability.reason?.description"
        [quantity]="availability.bagQuantity"
        [loading]="loading"
        (quantityChanged)="quantityChanged.emit($event)"
        [mode]="availability.bagQuantity > 0 ? 'controls-only' : 'no-controls'"
        [buttonSize]="buttonSize"
      ></x-add-to-cart-button>
    </ng-container>
  </ng-container>

  <ng-template #ELSE>
    <ng-container *ngIf="productView.variantAvailability as availability">
      <button
        class="options-button"
        [disabled]="availability.status === 'UNAVAILABLE'"
        mat-flat-button
        color="primary"
        [routerLink]="productView.detailUrl"
        [xButtonSize]="buttonSize"
      >
        <ng-container>
          {{ availability.status === 'UNAVAILABLE' ? 'Unavailable' : 'Options' }}
        </ng-container>
      </button>
    </ng-container>
  </ng-template>
</ng-container>
